import { FileRepository } from '~/repositories/fileRepository';
import { validateId } from '~/repositories/utils';
import { hoaServiceUrl } from '~/utils/env';
import { urlWithQuery } from '~/utils/url';
import type { CreateSurveyDto, SurveyDto, SurveyListDto, SurveyResultsDto, UpdateSurveyDto } from '~/swagger/hoa/Api';
import type { SurveyListFilter } from '~/utils/hoaSurvey';

const BASE_URL = `${hoaServiceUrl()}/company-portal/associations/surveys`;

export type { SurveyListFilter };

export class SurveyRepository extends FileRepository {
  public async list(filter: SurveyListFilter): Promise<SurveyListDto> {
    const response = await this.fetchWithAuth(urlWithQuery(BASE_URL, filter));
    return this.getJsonResponse(response);
  }

  public async get(id: string): Promise<SurveyDto> {
    validateId(id, 'Survey');
    const response = await this.fetchWithAuth(`${BASE_URL}/${id}`);
    return this.getJsonResponse(response);
  }

  public async create(payload: CreateSurveyDto): Promise<SurveyDto> {
    const response = await this.fetchWithAuth(BASE_URL, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async update(id: string, payload: UpdateSurveyDto): Promise<SurveyDto> {
    validateId(id, 'Survey');
    const response = await this.fetchWithAuth(`${BASE_URL}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async publish(id: string): Promise<SurveyDto> {
    validateId(id, 'Survey');
    const response = await this.fetchWithAuth(`${BASE_URL}/${id}/publish`, { method: 'POST' });
    return this.getJsonResponse(response);
  }

  public async close(id: string): Promise<SurveyDto> {
    validateId(id, 'Survey');
    const response = await this.fetchWithAuth(`${BASE_URL}/${id}/close`, { method: 'POST' });
    return this.getJsonResponse(response);
  }

  public async getResults(id: string): Promise<SurveyResultsDto> {
    validateId(id, 'Survey');
    const response = await this.fetchWithAuth(`${BASE_URL}/${id}/results`);
    return this.getJsonResponse(response);
  }
}

export const surveyRepository = new SurveyRepository();
